var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.414,
    height: 8.62,
    viewBox: "0 0 14.414 8.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_697_2",
    "data-name": "Component 697 \\u2013 2",
    transform: "translate(13.707 7.913) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M1422.25,7925.5l6.5,6.5,6.5-6.5",
    transform: "translate(-1422.25 -7925.5)",
    fill: "none",
    stroke: "#222629",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrowUp);
export default __webpack_public_path__ + "static/media/accordion-arrow-up.93dcacb2a755b42b53114720f905f48a.svg";
export { ForwardRef as ReactComponent };